import React from 'react';

/**
 * Ventana de páginas como en Listar Pacientes / Empresas.
 * Hasta 10 páginas muestra todas (permite ir directo, ej. página 7).
 */
export function getPaginationItems(current, total) {
    if (total <= 10) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }
    if (current <= 4) {
        return [1, 2, 3, 4, '...', total];
    }
    if (current >= total - 3) {
        return [1, '...', total - 3, total - 2, total - 1, total];
    }
    return [1, '...', current - 1, current, current + 1, '...', total];
}

function PaginationBar({ paginaActual, totalPaginas, onPageChange, hideWhenSingle = true, className = '' }) {
    const total = Math.max(totalPaginas, 1);

    if (hideWhenSingle && totalPaginas <= 1) {
        return null;
    }

    const cambiarPagina = (page) => {
        if (page < 1 || page > total) return;
        onPageChange(page);
    };

    const paginaSegura = Math.min(Math.max(paginaActual, 1), total);
    const items = getPaginationItems(paginaSegura, total);

    return (
        <nav aria-label="Paginación" className={className}>
            <ul className="pagination pagination-sm mb-0 smile-pagination">
                <li className={`page-item ${paginaSegura <= 1 ? 'disabled' : ''}`}>
                    <button
                        type="button"
                        className="page-link smile-pagination-btn"
                        onClick={() => cambiarPagina(paginaSegura - 1)}
                        disabled={paginaSegura <= 1}
                        aria-label="Página anterior"
                    >
                        ‹
                    </button>
                </li>
                {items.map((item, idx) => {
                    if (item === '...') {
                        return (
                            <li key={`ellipsis-${idx}`} className="page-item disabled">
                                <span className="page-link smile-pagination-ellipsis">...</span>
                            </li>
                        );
                    }
                    const activa = paginaSegura === item;
                    return (
                        <li key={`page-${item}`} className={`page-item ${activa ? 'active' : ''}`}>
                            <button
                                type="button"
                                className={`page-link smile-pagination-btn${activa ? ' smile-pagination-btn--active' : ''}`}
                                onClick={() => cambiarPagina(item)}
                                aria-current={activa ? 'page' : undefined}
                            >
                                {item}
                            </button>
                        </li>
                    );
                })}
                <li className={`page-item ${paginaSegura >= total ? 'disabled' : ''}`}>
                    <button
                        type="button"
                        className="page-link smile-pagination-btn"
                        onClick={() => cambiarPagina(paginaSegura + 1)}
                        disabled={paginaSegura >= total}
                        aria-label="Página siguiente"
                    >
                        ›
                    </button>
                </li>
            </ul>
        </nav>
    );
}

export default PaginationBar;
